<template>
  <div>
  <div class="content">

    <b-container fluid class="mt-4">

      <stats-card title="Users" type="default" sub-title="All users" icon="fas fa-user">

        <template slot="actions">
            <a class="dropdown-item" href="javascript:void(0)" @click="showCreateModal = true">Create new</a>
        </template>

        <template slot="append">

          <base-alert>
            Last {{tableOptions.limit}} users created displayed here. Use the search bar below to fetch more.
          </base-alert>

          <div class="mt-4">
            <entity-picker v-if="usersData.length > 0"
                :canEdit="true"
                :canSelect="false"
                placeHolder="Start typing something..."
                apiEndpoint="getUsers"
                :selected="usersData"
                :cursorData="cursorData"
                editPath="/users/"
                :tableColumns= tableColumns
                :filters="userFilters"
                rootProp="users"
                :canExport="true"
                :tableOptions="tableOptions"
            >
            </entity-picker>
          </div>

        </template>
      </stats-card>
    </b-container>
  </div>

  <modal :show.sync="showCreateModal">
        <h6 slot="header" class="modal-title">Create User</h6>

        <base-input label="Name:" v-model="newUser.name"></base-input>
        <base-input label="Email:" v-model="newUser.email"></base-input>
        <phone-input label="Phone:" v-model="newUser.phone">
        </phone-input>
        <base-input label="Password:" placeholder="6 chars min." v-model="newUser.password"></base-input>

        <div class="form-check">
            <input type="checkbox" class="form-check-input" v-model="createActivate" id="createActivate">
            <label class="form-check-label" for="createActivate"><small>Activate user</small></label>
            <small class="form-text text-muted">Bypasses the email verification process if ticked</small>
        </div>

        <div class="form-check mt-3">
            <input type="checkbox" @change="fetchRolesIfNeeded" v-model="createDefault" class="form-check-input" id="createDefault">
            <label class="form-check-label" for="createDefault"><small>Create default Org / Farm / Orchard</small></label>
        </div>

        <div v-if="createDefault == true" class="mt-3">
          <base-alert>
            Pick a role for this user:
          </base-alert>

          <b-form-select v-if="addRoleOptions.length > 0" v-model="addRoleSelected" :options="addRoleOptions"></b-form-select>
        </div>

        <template slot="footer">
            <base-button type="blank" @click="showCreateModal = false">Cancel</base-button>
            <base-button :disabled="!isCreateUserFormValid()" type="success" @click="createNewUser">Create user</base-button>
        </template>
    </modal>

  </div>
</template>


<script>
import api from '@/api'
import { tableColumns, tableFilters, tableOptions } from '@/config/UserTable'
import BaseAlert from '../components/BaseAlert.vue';
// import { isValidPhone, isValidEmail  } from '@/util/validators';
import { UserModel  } from '@/models/user/user';

export default {
  components: {
    BaseAlert
  },
  data() {
    return {
      showLogAllOut: false,
      tableColumns: tableColumns,
      userFilters: tableFilters,
      tableOptions: tableOptions,
      newUser: new UserModel(),
      createActivate: true,
      createDefault: false,
      usersData: [],
      cursorData: null,
      selectedRows: [],
      addRoleOptions: [],
      showCreateModal: false,
      addRoleSelected: null,
    };
  },
  created: async function() {
    this.$emit('loading', true);
    const results = await api.getUsers({
      sort: this.tableOptions['default-sort'].prop,
      direction: this.tableOptions['default-sort'].order == 'ascending' ? 'asc' : 'desc',
      limit: this.tableOptions.limit
    })
    this.$emit('loading', false);
    this.usersData = results.users;
    this.cursorData = results.cursor
  },
  methods: {
    isCreateUserFormValid() {
      let valid = this.newUser.doesValidate() && this.newUser.password && this.newUser.password.length >= 6
      if(this.createDefault) {
        valid = valid && this.addRoleSelected != null
      }
      return valid
    },
    fetchRolesIfNeeded() {
      if(this.addRoleOptions.length == 0) {
        this.getAvailablePermissions()
      }
    },
    getAvailablePermissions: async function() {
        this.$emit('loading', true);
        const results = await api.getRoles()
        this.addRoleOptions = results.roles.map(function(r) {
            return {
                value: r.name,
                text: `${r.name} - ${r.description}`
            }
        })
        this.addRoleOptions.unshift({
            value: null,
            text: "Select..."
        })
        this.$emit('loading', false);
    },
    createNewUser: async function() {
      this.$emit('loading', true);

      let createDefaultPayload = {
        create: this.createDefault
      }

      if(this.createDefault) createDefaultPayload.role = this.addRoleSelected

      let payload = {
        ... this.newUser.exportToCreate(),
        activate: this.createActivate,
        password: this.newUser.password,
        defaults: createDefaultPayload
      }

      const results = await api.createUser(payload);
      this.$emit('loading', false);

      if(results) {
        this.showCreateModal = false;
        this.$emit('onApiResult', 'User created, redirecting now...');
        this.$router.push(`/users/${results.id}?created`);
      }
    }

  }
};
</script>
